import React, { useEffect, useState } from "react";
import GlobalCard from "../../../components/GlobalCardComponent";
import { Box, Card, Chip, Grid, Tooltip, Typography } from "@mui/material";
import PinkOutlinedButton from "../../../components/customButtons/PinkOutlinedButton";
import CustomPopup from "../../../components/customPopup/CustomPopup";
import RequestLeaveForm from "./RequestLeaveForm";
import DeleteConfirmationPopup from "../../../components/customPopup/DeleteConfirmationPopup";
import EditLeaveRequest from "./EditLeaveRequest";
import CustomSelectField from "../../../components/customFields/CustomSelectField";
import { fDate } from "../../../../utils2/formatTime";
import SussceeffulyMessageScreen from "../../../components/customPopup/SussceeffulyMessageScreen";
import { useLocation, useParams } from "react-router-dom";
import {
  handleCanceleaveRequest,
  handleFetchLeaveRequest,
} from "../../testPrepDashboard/Api/DashboardApi";
import Loader from "../../../../SAPPages/components/Loader/Loader";
import CustomPafinationComp from "../../allClasses/CustomPafinationComp";
import ErrorPopupScreen from "../../../components/customPopup/ErrorPopupScreen";
import CloseIcon from "@mui/icons-material/Close";
import CancelConfirmationPopup from "../../../components/customPopup/CancelConfirmationPopup";

export default function ViewLeaveRequest({ attendanceDetails }) {
  const { std_class_detail_id } = useParams();
  const userId = localStorage.getItem("userId");
  const location = useLocation();
  const [openleaveRequest, setOpenLeaveRequest] = useState(false);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [openCancelPopup, setOpenCancelPopup] = useState(false);
  const [openEditRequest, setOpenEditRequest] = useState(false);
  const [selectedOption, setSelectedOption] = useState("upcoming");
  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
  const [messageTitle, setMessageTitle] = useState(null);
  const [subMessage, setSubMessage] = useState(null);
  const [isDeleted, setIsDeleted] = useState(null);

  const [leaveData, setLeaveData] = useState([]);
  const [leavLoading, setLeaveLoading] = useState(true);

  const [optionData, setOptionData] = useState([
    { id: 1, value: "past", name: "Past" },

    {
      id: 3,
      value: "upcoming",
      name: "Upcoming",
    },
  ]);
  const [selectedData, setSelectedData] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const currentDate = new Date().toISOString().split("T")[0];

  // add leave popup
  const handleOpenLeavepopup = () => {
    setOpenLeaveRequest(true);
  };

  const handleCloseLeavepopup = () => {
    setOpenLeaveRequest(false);
  };

  // edit leave popup
  const handleOpenEditLeavepopup = (data) => {
    setOpenEditRequest(true);
    setSelectedData(data);
  };

  const handleCloseEditLeavepopup = () => {
    setOpenEditRequest(false);
  };

  // delete popop
  const handleOpendeletePopup = (leaveData) => {
    setOpenDeleteConfirmation(true);
    setSelectedData(leaveData);
    setIsDeleted(1);
  };

  const handleClosedeletePopup = () => {
    setOpenDeleteConfirmation(false);
  };

  // cancelpopup

  const handleOpenCancelPopup = (leaveData) => {
    setOpenCancelPopup(true);
    setSelectedData(leaveData);
    setIsDeleted(0);
  };

  const handleCloseCancelPopup = () => {
    setOpenCancelPopup(false);
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  // Status color map
  const statusStyles = {
    Approved: {
      background: "#4CAF501A", // Light green background
      color: "#4CAF50", // Green text
    },
    Pending: {
      background: "#FFA7261A", // Light orange background
      color: "#FB8C00", // Orange text
    },
    Cancelled: {
      background: "#EF53501A", // Light red background
      color: "#DA0303", // Red text
    },
    Denied: {
      background: "#EF53501A", // Light red background
      color: "#DA0303", // Red text
    },
    Default: {
      background: "#9D03850D", // Fallback (pinkish)
      color: "#9D0385",
    },
  };

  // open success popup
  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);

  // fetch leave request data
  const handlefetchLeaveDetails = async (selectedOption, page) => {
    setLeaveLoading(true);
    try {
      const response = await handleFetchLeaveRequest({
        user_id: parseInt(userId),

        student_class_details_id: std_class_detail_id,
        status: selectedOption,
        limit: 3,
        page,
      });

      if (response.status === 200) {
        setLeaveData(response?.data);
        setPagination(response?.pagination);
        setLeaveLoading(false);
      } else {
        setLeaveData([]);
        setLeaveLoading(false);
      }
    } catch (error) {
      setLeaveData([]);
      setLeaveLoading(false);
    }
  };

  useEffect(() => {
    handlefetchLeaveDetails(selectedOption, page);
  }, [selectedOption, page]);

  // cancel leave request and delete leave request
  const handleCancelLeaveRequest = async () => {
    try {
      const response = await handleCanceleaveRequest({
        user_id: parseInt(userId),

        id: selectedData?.id,

        is_deleted: isDeleted,
      });

      if (response.status === 200) {
        setMessageTitle(
          isDeleted === 1
            ? "Leave request deleted successfully."
            : "Leave request cancelled successfully."
        );
        setSubMessage(
          isDeleted === 1
            ? "Your leave request has been deleted."
            : "Your leave request has been cancelled."
        );
        handleClosedeletePopup();
        handleCloseCancelPopup();
        handleOpenSuccessPopup();
        if (isDeleted === 1) {
          const updatedData = leaveData?.filter(
            (data) => data?.id !== selectedData?.id
          );
          setLeaveData(updatedData);
        }
        if (isDeleted === 0) {
          // Update status to "Cancelled"
          const updatedData = leaveData?.map((data) => {
            if (data?.id === selectedData?.id) {
              return { ...data, status: "Cancelled" };
            }
            return data;
          });
          setLeaveData(updatedData);
        }
      } else {
        setErrorMessage(response?.message);
        handleOpenErrorPopup();
      }
    } catch (error) {
      setErrorMessage(error);
      handleOpenErrorPopup();
    }
  };

  return (
    <>
    <GlobalCard height="100%">
        {" "}
        <Grid container spacing={1} >
          <Grid item xs={6} sm={6} container gap={1} alignItems="center">
            <Box width={44}>
              <img src="/newdashboard/Classrom/Attendance/Group 1000016696 (4).png" />
            </Box>
            <Typography
              color="#000000"
              fontFamily="Inter"
              fontSize="18px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 400 }}
            >
              Leave Status
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} container gap={2} justifyContent="flex-end">
            {currentDate < attendanceDetails?.end_date && (
              <PinkOutlinedButton
                buttonTitle="Request leave"
                onClick={handleOpenLeavepopup}
              />
            )}
            <CustomSelectField
              ExpandMoreIconColor="#9D0385"
              width="auto"
              borderColor="#FEDDF9"
              fontWeight={700}
              color="#9D0385"
              options={optionData}
              getOptionLabel={(opt) => opt?.name}
              getOptionValue={(opt) => opt?.value}
              value={selectedOption}
              onChange={(e) => {
                setSelectedOption(e.target.value);
                setPage(1);
              }}
            />
          </Grid>

          <Grid item xs={12}>
            {" "}
            <Box height="1px" sx={{ background: "#dddddd" }} width="100%"></Box>
          </Grid>
          {leavLoading ? (
            <Grid item xs={12}>
              <Loader text="Loading Leave Details..." />
            </Grid>
          ) : !leavLoading && leaveData.length === 0 ? (
            <Grid
              mt={2}
              mb={2}
              item
              xs={12}
              container
              justifyContent="center"
              direction="column"
              alignItems="center"
            >
              <Box width={44}>
                <img src="/newdashboard/Classrom/Attendance/uis_calender (2).png" />
              </Box>
              <Typography
                mt={2}
                color="#999999"
                fontFamily="Inter"
                fontSize="14px"
                lineHeight="100%"
                letterSpacing="0px"
                fontStyle="normal"
                style={{ fontWeight: 700 }}
              >
                No Class Leave Request
              </Typography>

              <Typography
                mt={1}
                color="#999999"
                fontFamily="Inter"
                fontSize="12px"
                lineHeight="100%"
                letterSpacing="0px"
                fontStyle="normal"
                style={{ fontWeight: 400 }}
              >
                You haven’t requested any leave yet
              </Typography>
            </Grid>
          ) : (
            <>
              <Grid item xs={12} mt={2}>
                <Grid container spacing={3}>
                  {leaveData?.map((leave) => {
                    const { background, color } =
                      statusStyles[leave?.status] || statusStyles.Default;
                    return (
                      <>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <GlobalCard>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Typography
                                  color="#000000"
                                  fontFamily="Inter"
                                  fontSize="16px"
                                  lineHeight="100%"
                                  letterSpacing="0px"
                                  fontStyle="normal"
                                  style={{ fontWeight: 400 }}
                                >
                                  {fDate(leave?.start_date)}
                                </Typography>
                              </Grid>
                              <Grid item xs={6} textAlign="end">
                                {leave?.no_of_days && (
                                  <Chip
                                    label={` ${leave?.no_of_days} Days`}
                                    size="small"
                                    sx={{
                                      background: "#9D03850D",
                                      color: "#9D0385",
                                      fontFamily: "Inter",
                                      fontWeight: 700,
                                      fontSize: "12px",
                                      px: 1.2,
                                      py: 0.6,
                                    }}
                                  />
                                )}
                              </Grid>

                              <Grid item xs={12}>
                                <Typography
                                  color="#777777"
                                  fontFamily="Inter"
                                  fontSize="13px"
                                  lineHeight="100%"
                                  letterSpacing="0px"
                                  fontStyle="normal"
                                  style={{ fontWeight: 700 }}
                                >
                                  Reason :{" "}
                                  <span
                                    style={{
                                      fontWeight: 400,
                                      color: "#111111",
                                    }}
                                  >
                                    {" "}
                                    {leave?.reason}
                                  </span>
                                </Typography>
                              </Grid>

                              <Grid item xs={6} mt={1}>
                                <Chip
                                  size="small"
                                  label={leave?.status}
                                  sx={{
                                    background,
                                    color,
                                    fontFamily: "Inter",
                                    fontWeight: 700,
                                    fontSize: "12px",
                                    px: 1.2,
                                    py: 0.6,
                                  }}
                                />
                              </Grid>
                              {leave?.status === "Approved" &&
                                selectedOption === "upcoming" &&
                                (
                                  <Grid item xs={6} mt={1} textAlign="end">
                                    <Tooltip title="Cancel">
                                      <CloseIcon
                                        style={{
                                          color: "#DA0303",
                                          fontSize: "1rem",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          handleOpenCancelPopup(leave)
                                        }
                                      />
                                    </Tooltip>
                                  </Grid>
                                )}

                              {leave?.status === "Pending" &&
                                selectedOption === "upcoming" &&
                                currentDate < attendanceDetails?.end_date && (
                                  <Grid item xs={6} mt={1} textAlign="end">
                                    <Box
                                      display="flex"
                                      gap={1}
                                      justifyContent="flex-end"
                                    >
                                      <Box
                                        width={16}
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleOpenEditLeavepopup(leave)
                                        }
                                      >
                                        <Tooltip title="Edit">
                                          <img src="/newdashboard/Classrom/Attendance/mynaui_edit-solid.png" />
                                        </Tooltip>
                                      </Box>

                                      <Box
                                        width={16}
                                        sx={{ cursor: "pointer" }}
                                        onClick={() =>
                                          handleOpendeletePopup(leave)
                                        }
                                      >
                                        <Tooltip title="Delete">
                                          <img src="/newdashboard/Classrom/Attendance/material-symbols-light_delete.png" />
                                        </Tooltip>
                                      </Box>
                                    </Box>
                                  </Grid>
                                )}
                            </Grid>
                          </GlobalCard>
                        </Grid>
                      </>
                    );
                  })}
                </Grid>
              </Grid>

              <Grid item xs={12} mt={2}>
                {pagination && (
                  <CustomPafinationComp
                    currentPage={pagination?.current_page}
                    totalPages={pagination?.total_page}
                    onPageChange={setPage}
                  />
                )}
              </Grid>
            </>
          )}
        </Grid>
      </GlobalCard>

      <CustomPopup
        handleClose={handleCloseLeavepopup}
        component={
          <RequestLeaveForm
            handleClose={handleCloseLeavepopup}
            setSubMessage={setSubMessage}
            setMessageTitle={setMessageTitle}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
          />
        }
        title="Leave Request"
        open={openleaveRequest}
        titleColor="#572575"
        maxWidth="xs"
        titleAlign="start"
      />

      <CustomPopup
        handleClose={handleCloseEditLeavepopup}
        component={
          <EditLeaveRequest
            handleClose={handleCloseEditLeavepopup}
            selectedData={selectedData}
            setSubMessage={setSubMessage}
            setMessageTitle={setMessageTitle}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
          />
        }
        title="Edit Leave Request"
        open={openEditRequest}
        titleColor="#572575"
        maxWidth="xs"
        titleAlign="start"
      />

      {/* Delete confirmation popup */}
      <DeleteConfirmationPopup
        open={openDeleteConfirmation}
        text="Delete Leave Request ?"
        subtext="Are you sure you want to delete this leave request ?"
        buttonTitle="Yes, Remove It"
        handleClose={handleClosedeletePopup}
        handleSubmit={handleCancelLeaveRequest}
      />

      <CancelConfirmationPopup
        open={openCancelPopup}
        text="Cancel Approved Leave  ?"
        subtext={`Are you sure you want to cancel your approved leave for `}
        boldText={`${fDate(selectedData?.start_date)} ?`}
        buttonTitle="Yes, Cancel Leave"
        handleClose={handleCloseCancelPopup}
        handleSubmit={handleCancelLeaveRequest}
      />

      <SussceeffulyMessageScreen
        text={messageTitle}
        subText={subMessage}
        buttonTitle="Thanks, Got it"
        navigateLink={location.pathname}
        currentLink={location.pathname}
        handleClose={handleCloseSuccessPopup}
        open={openSuccesPopup}
      />

      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle="Got It"
        maxWidth="xs"
      />
    </>
  );
}
